import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { Container } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { Navigation } from '@plone/volto/components';
import {
  HeaderBrand,
  HeaderTopLink,
  HeaderTopRightMore,
} from '@redturtle/iovisit-theme/components/layout';

import { SocialLinks } from 'volto-social-settings';

const messages = defineMessages({
  closeMobileMenu: {
    id: 'Close menu',
    defaultMessage: 'Close menu',
  },
  openMobileMenu: {
    id: 'Open menu',
    defaultMessage: 'Open menu',
  },
});

const HeaderMain = ({ pathname }) => {
  const intl = useIntl();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const handleSticky = () => {
    if (window.scrollY > 100) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleSticky, false);
    return () => {
      window.removeEventListener('scroll', handleSticky, false);
    };
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [pathname]);

  const Hamburger = () => (
    <div className="hamburger-wrapper mobile tablet computer only">
      <button
        className={cx('hamburger hamburger--collapse', {
          'is-active': isMobileMenuOpen,
        })}
        aria-label={
          isMobileMenuOpen
            ? intl.formatMessage(messages.closeMobileMenu)
            : intl.formatMessage(messages.openMobileMenu)
        }
        title={
          isMobileMenuOpen
            ? intl.formatMessage(messages.closeMobileMenu)
            : intl.formatMessage(messages.openMobileMenu)
        }
        type="button"
        onClick={() => {
          setIsMobileMenuOpen(!isMobileMenuOpen);
          setTimeout(function () {
            if (!isMobileMenuOpen) {
              document
                .querySelector('.hamburger-wrapper button.hamburger.is-active')
                .focus();
            }
          }, 100);
        }}
      >
        <span className="hamburger-box">
          <span className="hamburger-inner" />
        </span>
      </button>
    </div>
  );

  return (
    <div className={cx('iv--header-main', { sticky: isSticky })}>
      <Container>
        <div className="iv--header-main-content">
          <div className="iv--logo-nav-wrapper">
            <HeaderBrand />
            <div
              className={cx('iv--main-navigation', {
                'is-open': isMobileMenuOpen,
              })}
            >
              <div className="iv--menu-wrapper">
                {/*Close Mobile menu*/}
                <Hamburger />

                <div className="iv--mobile-menu-header ui mobile tablet computer only">
                  <HeaderBrand />
                  <SocialLinks />
                  <HeaderTopRightMore />
                </div>
                <div id="navigation">
                  <Navigation pathname={pathname} />
                </div>
                <div className="iv--mobile-menu-footer ui mobile tablet computer only">
                  <HeaderTopLink />
                </div>
              </div>

              {/* Open mobile menu*/}
              <Hamburger />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeaderMain;
